import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import ButtonCounter, { SIZE } from '@components/ButtonCounter';
import OptionDescription from '../OptionDescription';

const StyledOptionRowCounterContainer = styled.div`
  ${({ theme }) => theme.fontFamily.secondaryFont.smallRegular};
  display: flex;
  min-height: 8vh;
  align-items: center;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.elementLine};
  }

  ${props =>
    props.selected &&
    css`
      font-weight: bold;
    `}
`;

const StyledNameContainer = styled.div`
  flex-grow: 1;
  text-align: left;
`;

const StyledCounterContainer = styled.div`
  padding: 0 5px;
`;

function OptionRowCounter({
  option,
  onChangeQuantity,
  quantity,
  amount,
  modifiesPrice,
}) {
  return (
    <StyledOptionRowCounterContainer selected={quantity > 0}>
      <StyledNameContainer>
        <span>{option.name}</span>
        <OptionDescription amount={amount} modifiesPrice={modifiesPrice} />
      </StyledNameContainer>
      <StyledCounterContainer>
        <ButtonCounter
          onChangeQuantity={onChangeQuantity}
          quantity={quantity}
          size={SIZE.SMALL}
        />
      </StyledCounterContainer>
    </StyledOptionRowCounterContainer>
  );
}

OptionRowCounter.propTypes = {
  option: PropTypes.object.isRequired,
  quantity: PropTypes.number.isRequired,
  amount: PropTypes.number.isRequired,
  modifiesPrice: PropTypes.bool.isRequired,
  onChangeQuantity: PropTypes.func.isRequired,
};

export default OptionRowCounter;
